import { render, staticRenderFns } from "./CustomTreeItem.vue?vue&type=template&id=70373dec&"
import script from "./CustomTreeItem.vue?vue&type=script&lang=js&"
export * from "./CustomTreeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports